import { gql } from '@apollo/client'

export const GET_MOMENTS_BY_EPISODE_GUID = gql`
  query getMomentsByEpisodeGuid($guid: ID) {
    episode(guid: $guid) {
      id
      projectSlug
      displayScenePanel
      moments {
        id
        title
        type
        hasStory
        startTime
        projectSlug
        thumbnail
        endTime
        defaultOffer {
          id
          name
          description
          products {
            ... on CollectibleProductMoment {
              id
              name
              description
              momentId
              price
              quantity
              moment {
                id
                title
                type
                availableFrames
                reactionCount
                thumbnail
                startTime
                episode {
                  id
                  show {
                    name
                  }
                  season {
                    seasonNumber
                  }
                  episodeNumber
                }
              }
            }
            ... on CollectibleProductSignature {
              id
              signerName
              signerUuid
              signerImage
              price
              quantity
              signerId
            }
          }
        }
        episode {
          id
          guid
        }
      }
    }
  }
`

export const GET_MOMENT_BY_ID = gql`
  query getMomentById($id: ID!) {
    moment(id: $id) {
      id
      title
      type
      hasStory
      startTime
      thumbnail
      endTime
      defaultOffer {
        id
        name
        description
        products {
          ... on CollectibleProductMoment {
            id
            name
            description
            momentId
            price
            quantity
            moment {
              id
              title
              type
              availableFrames
              reactionCount
              thumbnail
              startTime
              episode {
                id
                show {
                  name
                }
                season {
                  seasonNumber
                }
                episodeNumber
              }
            }
          }
          ... on CollectibleProductSignature {
            id
            signerName
            signerUuid
            signerImage
            price
            quantity
            signerId
          }
        }
      }
    }
  }
`

export const GET_MOMENT_OWNERS = gql`
  query getMomentOwners(
    $momentId: ID!
    $includeMyStory: Boolean!
    $userId: String!
    $ownerCount: Int
    $actorCount: Int
    $userStoriesTake: Int
    $userStoriesSkip: Int
  ) {
    moment(id: $momentId) {
      id
      isOwner
      totalNumberOfOwners
      availableFrames
      userStory @include(if: $includeMyStory) {
        id
        text
        videoUri
        publishDate
        totalLikes
        isLikedByUser
        momentId
      }
      owners(count: $ownerCount) {
        id
        profile {
          id
          image(fallbackToInitials: true)
          firstName
          lastName
        }
        story: userStoryByMoment(momentId: $momentId) {
          id
          text
          videoUri
          publishDate
          totalLikes
          isLikedByUser
          momentId
        }
      }
      actors: owners(type: ACTOR, count: $actorCount) {
        id
        profile {
          id
          image(fallbackToInitials: true)
          firstName
          lastName
        }
        story: userStoryByMoment(momentId: $momentId) {
          id
          text
          videoUri
          publishDate
          totalLikes
          isLikedByUser
        }
      }
    }
    myStory: userStories(userStoriesInput: { where: { momentId: $momentId, userId: $userId } })
      @include(if: $includeMyStory) {
      stories {
        id
        text
        videoUri
        totalLikes
        isLikedByUser
        publishDate
      }
    }
    userStories(userStoriesInput: { where: { momentId: $momentId }, skip: $userStoriesSkip, take: $userStoriesTake }) {
      totalStories
      stories {
        id
        createdAt
        posterCloudinaryPath
        text
        videoUri
        title
        publishDate
        totalLikes
        isLikedByUser
        momentId
        user {
          id
          profile {
            id
            firstName
            lastName
            image(fallbackToInitials: true)
          }
        }
      }
    }
  }
`
